import { Fishx, i18n } from 'fishx';
import { message } from '@whalecloud/fdx';
import { login, zmpLogin, logout, changeUserPwd, qryCurrentSecurityRule, getVerifyAndSmsCodeEnabled } from '@/services/api';
import { getPageQuery } from '@/utils/utils'; // tokenCountDown,
import { Reducer, Effect, ConnectState } from '@/typings/connect.d';
import { SecurityRuleType, UserMsgType } from '@/typings/data.d';

export interface LoginStateType {
  isSuccess: undefined | number;
  resetModal: boolean;
  securityRule: SecurityRuleType;
  userMsg: UserMsgType;
  veriyfyConfig: any;
  userInfo: {
    envId: number;
    userId: number;
    userName: string;
    userCode: string;
  };
}

export interface LoginModelType {
  namespace: string;
  state: LoginStateType;
  effects: {
    login: Effect;
    zmpLogin: Effect;
    changeUserPwd: Effect;
    getVerifyAndSmsCodeEnabled: Effect;
    qryCurrentSecurityRule: Effect;
    logout: Effect;
  };
  reducers: {
    changeLoginStatus: Reducer<LoginStateType>;
    save: Reducer<LoginStateType>;
    closeModal: Reducer<LoginStateType>;
  };
}

const Model: LoginModelType = {
  namespace: 'dxpLogin',
  state: {
    isSuccess: undefined,
    resetModal: false,
    securityRule: {},
    userMsg: {
      userCode: '',
    },
    userInfo: {
      envId: 1001,
      userId: 1001,
      userName: 'react',
      userCode: 'react',
    },
    veriyfyConfig: {},
  },

  effects: {
    *login({ payload }, { call, put }) {
      const { success, errorMsg, data } = yield call(login, payload);
      const { isSuccess, ...rest } = data;
      if (success) {
        if (isSuccess && isSuccess === 1) {
          yield put({
            type: 'changeLoginStatus',
            payload: data,
          });
          const { redirect } = getPageQuery();
          let redirectUrl = redirect;
          // string 类型
          if (typeof redirect === 'string') {
            const hash = new URL(window.location.href);
            if (hash) {
              redirectUrl = redirect.replace(/#\//, '/');
            } else {
              redirectUrl = redirect.replace(/\/portal\//, '/');
            }
          }
          yield put({
            type: 'dxpGlobal/logged',
            payload: {
              from: 'Login',
              password: payload.password,
              redirect: redirectUrl,
            },
          });
        }
      } else if (data.code === 'POT-ACCOUNT-00007' || data.code === 'POT-LOGIN-00014' || data.code === 'POT-LOGIN-00020') {
        // 2021-07-21 交付测试的portal会有POT-LOGIN-00020这个code，报错提示首次登陆，要修改密码登陆
        // 默认密码和密码安全等级低时
        message.warning(`${data.message}${i18n('CHANGE_PWD_MSG')}`);

        // 首次登录 重置密码
        // 不符合安全规则 重置密码
        yield put({
          type: 'qryCurrentSecurityRule',
          payload,
        });
      } else if (data.code) {
        message.warning(`${data.message}`);
      } else throw errorMsg;
      return rest;
    },

    *zmpLogin({ payload }, { put, call, select }) {
      const { success, data } = yield call(zmpLogin, payload);
      const { isSuccess, ...rest } = data;
      const userInfo = yield select((state: ConnectState) => state.dxpLogin.userInfo);
      if (!success && isSuccess === 1) {
        message.warn(i18n('ERROR_USER_OR_PWD'));
      } else {
        yield put({
          type: 'save',
          payload: {
            userInfo: {
              ...userInfo,
              ...rest,
            },
          },
        });
        yield put({
          type: 'dxpGlobal/logged',
          payload: {
            from: 'Login',
            password: payload.password,
            redirect: '/',
          },
        });
      }
      return rest;
    },

    *changeUserPwd({ payload }, { call, put, select }) {
      const { success } = yield call(changeUserPwd, payload);
      if (success) {
        message.success(i18n('CHANGE_PWD_SUCCESS'));
        yield put({
          type: 'closeModal',
        });
        const { userMsg } = yield select((state: ConnectState) => state.dxpLogin);
        yield put({
          type: 'login',
          payload: {
            username: userMsg.username,
            password: payload.newPwd,
          },
        });
      }
    },

    *getVerifyAndSmsCodeEnabled(_, { call, put }) {
      const { success, data } = yield call(getVerifyAndSmsCodeEnabled);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            veriyfyConfig: data,
          },
        });
      }
    },

    *qryCurrentSecurityRule({ payload }, { call, put }) {
      const { success, data } = yield call(qryCurrentSecurityRule);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            securityRule: data,
            resetModal: true,
            userMsg: payload,
          },
        });
      }
    },

    *logout(_, { call, put }) {
      const res = yield call(logout);
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: false,
        },
      });
      yield put({
        type: 'dxpGlobal/updateState',
        payload: {
          currentUser: {},
        },
      });
      Fishx.history.push('/userLogin');
      return res;
    },
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    closeModal(state, { payload }) {
      return {
        ...state,
        ...payload,
        resetModal: false,
      };
    },
  },
};

export default Model;
